var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.63745 34.3571C3.63745 35.8239 4.84535 37.0318 6.31208 37.0318H17.7871V22.5046H3.63745V34.3571Z",
    fill: "#253748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0842 37.0425H31.5593C33.026 37.0425 34.2339 35.8346 34.2339 34.3679V22.5154H20.0842V37.0425Z",
    fill: "#253748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6114 11.0297H28.1405C32.2819 9.32568 34.2339 6.58634 34.2339 4.40781C34.2339 2.48811 32.7672 0.255658 28.6151 0.244873C23.4384 0.244873 20.4402 3.92249 18.9303 7.42755C17.4312 3.93328 14.4331 0.255658 9.25635 0.255658C5.1042 0.255658 3.63747 2.4989 3.63747 4.41859C3.63747 6.59712 5.57873 9.33646 9.73088 11.0405H3.24922C1.78248 11.0405 0.574585 12.2484 0.574585 13.7151V17.5437C0.574585 19.0104 1.78248 20.2183 3.24922 20.2183H17.7871V12.6043C18.1646 12.615 18.5421 12.6366 18.9303 12.6366C19.3294 12.6366 19.696 12.615 20.0735 12.6043V20.2183H34.6114C36.0782 20.2183 37.286 19.0104 37.286 17.5437V13.7151C37.286 12.2484 36.0782 11.0405 34.6114 11.0405V11.0297ZM28.6151 2.55282C30.222 2.55282 31.9368 3.03814 31.9368 4.41859C31.9368 5.3353 31.1603 6.79125 28.9818 8.07464C27.4072 9.00213 24.6894 10.1022 20.3647 10.3071C21.0549 7.76188 23.1364 2.55282 28.6151 2.55282ZM5.93463 4.41859C5.93463 3.04892 7.64941 2.55282 9.25635 2.55282C14.735 2.55282 16.8165 7.76188 17.5067 10.3071C9.35341 9.92962 5.93463 6.37064 5.93463 4.41859Z",
    fill: "#253748"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_81"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.7115,
    height: 36.787,
    fill: "white",
    transform: "translate(0.574585 0.255615)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresent);
export default __webpack_public_path__ + "static/media/present.3123c37d529d73bf2f8c01d295db027c.svg";
export { ForwardRef as ReactComponent };